export const isNewSystem = () => {
  const workspace = window.location.href.replace(/https?:\/\//ig, '').replace(/\.app\.merciyanis\.(com|io)/ig, '').split('/')[0];
  return workspace !== 'app.merciyanis.com' && ![
    'v1',
    'nestle-vittel',
    'delachaux-morganlewis',
    'netflix',
    'edenred',
    'iot-spie-dgin',
    'sgs',
    'metropole-clermont-ferrand',
    'festyland',
    'toulouse-metropole-habitat',
    'atalian-airfrance',
    'omnes-education-pesee',
    'cle-expertises',
    'enedis-pradettes',
    'gsfnantesnord',
    'safran-malakoff',
    'ccial-meru',
    'oryon-app-merciyanis-com',
    'oryon',
    'testguiloom',
    'aeroport-marignane',
    'carsat',
    'thalie-sante',
    'vinci-thales-meudon',
    'caas',
    'nfms-um6p',
    'gsfnantes',
    'marche-st-pierre',
    'wendel',
    'brakina-oua',
    'cpo-total-energies',
    'laboratoires-besins-cb21',
    'oney',
    'atalian-schneider',
    'agglomeration-cergy-pontoise',
    'adobe-paris',
    'aeroport-pau',
    'apave',
    'ads',
    'a-g-net',
    'banque-de-france',
    'cargill',
    'centre-auto-dialyse-drancy',
    'ch-mont-de-marsan',
    'cimo',
    'conseil-general-gironde',
    'demo-ams-proprete',
    'demo-dosim',
    'demo-inpx',
    'demo-oms-synergie',
    'demo-servicenow',
    'demo-topnet',
    'dhl',
    'esg-saclay',
    'etoile-saint-honore',
    'freewheel',
    'ghu-paris',
    'nestle',
    'gsf-parc-zoologique-paris',
    'doctolib',
    'ict-france',
    'jade',
    'insitu-batiment-landing',
    'kumquat',
    'lvmh-holding',
    'master-net-multiservices',
    'nexity',
    'oceane',
    'orfea',
    'les3fontaines',
    'proprete-formation',
    'quarantesix',
    'puissance5',
    'sg-clients',
    'servia-services',
    'socgen',
    'spie-immo',
    'test-basf',
    'test-elise-2',
    'thales-aix',
    'ams',
    'base-test-noval',
    'caf-du-nord',
    'centre-commercial-velizy2',
    'chanel',
    'clean-system-jo',
    'cleany',
    'coop-aclens',
    'demo-deca-proprete',
    'demo-esg',
    'demo-nsi-groupe',
    'demo-servy-clean',
    'demo-tech-net',
    'edf-dampierre',
    'esigelec',
    'essity',
    'euptouyou',
    'groupe-audiens',
    'gsf-neuflize',
    'guerlain',
    'guima-nettoyage',
    'kaamelott',
    'latham-watkins',
    'lepine',
    'macdonald',
    'metropole-nice',
    'mtp-services',
    'studiotf1',
    'ovh',
    'pns',
    'pronovias',
    'renault-trucks',
    'safran-nacelles',
    'sls-grenoble-sud',
    'stef',
    'storengy',
    'test-bovis-facilities',
    'test-cryptr',
    'testjordan',
    'tzanck-stlaurent',
    'universite-grenoble',
    'ville-evrard',
    'xylem',
    'capitole',
    'barry-callebaut',
    'nom-du-workspace',
    'ales-groupe',
    'a-g-net-ephad',
    'basf',
    'cbre-courbevoie',
    'centre-estivage-iganis',
    'chpg',
    'clarins',
    'crystal',
    'demo-apr',
    'demo-elior',
    'demo-groupe-saturne',
    'demo-pearl-housekeeping',
    'demo-pro-impec',
    'demo-stn',
    'ecoublay',
    'eyco',
    'galeries-lafayette',
    'gsf-aerogarerennes',
    'gsf-chucaen',
    'haussmann',
    'ieseg',
    'iotvalley',
    'lacoste',
    'leroy-merlin',
    'mairie-asnieres',
    'mediatheque-riom',
    'mutualite-francaise',
    'neptune-est',
    'oms-safran',
    'peintisol',
    'pole-sante-bergere',
    'pro-impec',
    'renault',
    'safran-electronics-defense',
    'sg-demo',
    'showroom',
    't2mc',
    'template',
    //'fnacdarty',
    'test-fnacdarty',
    'testworkspace',
    'u-bordeaux-montaigne',
    'universite-belfort',
    'sony-europe',
    'witco',
    'bouznika',
    'bovis-facilities',
    'acb',
    'aquascope',
    'bcg',
    'capitole-nanterre',
    'carrefourproperty',
    'cgi',
    'cleaners-and-co',
    'data-valley',
    'demo-armonia',
    'demo-cofraneth',
    'demo-gsf-commerce',
    'demo-polaris',
    'demo-qrcode',
    'demo-teamex',
    'dunkerque-marina',
    'espace4',
    'eurofin',
    'groupe-up',
    'guillaume',
    'ikea-tourville',
    'gsfnantesest',
    'les-flanades',
    'malraux-hoche',
    'mc-arthurglen',
    'ministere-de-l-economie',
    'nsi-piscines',
    'oms-synergie',
    'offiscenie',
    'pommier',
    'qrcode-4en1-proprete',
    'residence-enva',
    'sazarias',
    'slean',
    'stellantis',
    'synchrotron-soleil',
    'test-creation',
    'test-nouvelatrium',
    'total-energies-lubrifiant',
    'transdev',
    'vebego',
    'vinci-bordeaux',
    'bpce',
    'aivancity',
    'piscine-palais-des-sports',
    'altum-services',
    'auchan-la-cloche-dor',
    'borealis',
    'cc-italie-2',
    'cfa-bretagne',
    'ch-cadillac',
    'clean-system',
    'cplusnet-tourpacific',
    'demo-arcade',
    'demo-ecoclean',
    'demo-igs',
    'demo-puissance5',
    'demo-proprete',
    'demobnp',
    'esperance',
    'florian',
    'france-travail',
    'grt-gaz',
    'gsf-roullier',
    'hopital-de-saint-dizier',
    'inrs',
    'kddi',
    'kedge-talence',
    'les-champs-libres',
    'logistique-galeries-lafayette',
    'medtronic-grenoble',
    'mgen',
    'nse-riom',
    'groupe-pichet',
    'plead',
    'pole-emploi-auvergne',
    'quartus',
    'residhome-ponts-jumeaux',
    'samsonite',
    'sncf',
    'stmicroelectronics-le-mans',
    'seta',
    'test-deskare',
    'stmicroelectronics',
    'thales-cannes',
    'transdev-lyon',
    'veltys-max',
    'visite-danone',
    'zeop',
    'bureau-veritas',
    'atalian',
    'grand-palais',
    'aspen',
    'bny',
    'ccamcs',
    'cg93',
    'ch-guillaume-regnier',
    'colas-miro',
    'decathlon-campus',
    'demo-armor-nettoyage',
    'danone',
    'demo-merciyanis',
    'demo-pro-net',
    'demo-samsic',
    'demo-vebego',
    'efficience',
    'essi-saphir',
    'formation-merciyanis',
    'gsf-amiens',
    'givenchy',
    'hyclean',
    'intervet',
    'keolis',
    'leclerc-bois-d-arcy',
    'lidl',
    'marie-brizard',
    'malakoff-humanis',
    'multi-sites',
    'nxp',
    'orrick',
    'manutan',
    'naama',
    'privilege',
    'scor',
    'sailing-lab',
    'prevoir',
    'style-outlet-roppenheim',
    'technicolor',
    'test-elise',
    'test-pti',
    'theatre-richelieu',
    'tutu',
    'ville-arpajon',
    'walterpatriarche',
    'campagne-ads',
    'banque-pictet',
    'ubs-monaco',
    'armatis',
    'bordeaux-la-tulle',
    'centralesupelec',
    'ciej',
    'chanteloup-les-vignes',
    'clermont-auvergne-metropole',
    'danone-research',
    'demo-atalian',
    'demo-facilibot',
    'demo-iss-onet',
    'continental',
    'demo-stem-groupe',
    'deskare',
    'edf-sapn',
    'edfblayais',
    'forvia',
    'geg',
    'gsf-sanofipasteur',
    'habitat-77',
    'intersport',
    'kremlin-bicetre',
    'le-florestan',
    'limoges-metropole',
    'mas-de-poissy',
    'medtronic-trevoux',
    'oceane-de-nettoyage',
    'operadelyon',
    'plastuni',
    'portlarochelle',
    'qrcode-idet',
    'rive-de-paris',
    'sdis-22',
    'services-generaux-formation',
    'snef',
    'supermarches-coop',
    't2mc-lillemetropole',
    'test-s2h',
    // 'total-newton',
    'tribunal-castres-albi',
    'vinci',
    'voodoo',
    'ca-pyrenees-gascogne',
    'biolab33',
    'arkane-lyon',
    'sanisphere',
    'axa-angers',
    'bruneau',
    'bredinprat',
    'chancellerie-paris',
    'cityscope',
    'cm-cic',
    'cpam-bordeaux',
    'demo',
    'demo-iss',
    'demo-qrcode-det',
    'demo-signature-services',
    'dior-parfums',
    'ds-smith-rochechouart',
    'esp-demo',
    'fnacnice',
    'general-mills-labatut',
    'gsf-soutenance',
    'gsf-rnt',
    'hospices-lyon',
    'krys',
    'leclerc-mios',
    'hemeria',
    'maintners',
    'merciyanis-qrcodes-4en1',
    'metpark',
    'ocp-mayssane',
    'placedesservices',
    'pro-impec-demo',
    'regus',
    'sacem',
    'scc-demo',
    'sercel-saintgaudens',
    'sncf-connect',
    'symbiose',
    'sorare',
    'futuroscope',
    'test-socgen',
    'urssaf',
    'valentin',
    'insitu',
    'boiron',
    'bessac',
    'saint-hilaire-proprete',
    'multidex',
    'azul-services',
    'c-net-demo',
    'cci-toulouse',
    'ch-st-cyr-mont-d-or',
    'citeo',
    'colliers',
    'danone-haussmann',
    'demo-clean-system',
    'demo-europ-net',
    'demo-kiklean',
    'demo-onet',
    'demo-sodexo',
    'demolaprovidence',
    'epfl',
    'etat-de-vaud',
    'faurecia',
    'flexim',
    'diot-siaci',
    'gsf-scenario2',
    'ibis-bordeaux',
    'issy-les-moulineaux',
    'jacquemus',
    'lemet',
    'lvmh',
    'mcarthurglen',
    'mercijack',
    'myfoodcourt',
    'omnes-education',
    'pluralis-habitat',
    'prefecture-haute-garonne',
    'remy-cointreau',
    'rubix',
    'skiply',
    'socgen-lesdunes',
    'stn-groupe',
    'terreal',
    'tbs',
    'test-teams',
    'trane',
    'syngenta',
    'vauban',
    'vincifacilities',
    'wework',
    'btwin-village',
    'aeroport-de-toulouse',
    'armonia-itm',
    'balenciaga',
    'cabo',
    'centralesupelec-interne',
    'chronopost',
    'aural-metz-tessy',
    'clean-service-demo',
    'continental-automotive-france',
    'coop-leman',
    'demo-cejip',
    'demo-innoclean',
    'demo-multis-proprete-services',
    'demo-servia',
    'demo-rondes',
    'derichebourg',
    'espacil',
    'foyer-group',
    'centre-pompidou',
    'gsf-rex',
    'gsf-stefdarvault',
    'hpgs',
    'ilv',
    'la-vache-noire',
    'lefebvre-dalloz',
    'lvmh-workplace-management',
    'leclerc-lateste',
    'messerli',
    'naama-lvmh-paris',
    'ocp-cerphos',
    'payfit',
    'pms-france',
    'public-senat',
    'recrutement',
    'safran-eragny',
    'sezane',
    'seine-st-denis',
    'sodexo',
    'sercel-carquefou',
    'ten',
    'societe-generale',
    'test-videlio',
    'toulouse-metropole-secteur6',
    'vendome',
    'vinci-facilities',
    'wpm2023',
    'bosch-valbonne',
    'amadeus',
    'test-elise-ok',
    'club-sidi-bouzid',
    'piscine-palais-sports-puteaux',
    'pommier-beauchamps',
    'maison-sante-angerville',
    'aja-formation',
    'pinault-collection',
    'musee-grevin',
    'unilabs',
    'thales',
    'maison-du-monde',
    'phyteis',
    'chs-savoie',
    'lautre-usine',
    'reine-dijon',
    'little-green-house',
    'artemys-manutan',
    'ville-angers',
    'velizy-bercy',
    'hotel-de-la-marine',
    'vgrf',
    'conseil-departemental-pau',
    'test-matthieu',
    'outlet-aubonne',
    'manpowergroup',
    'synlab',
    'yso-hygiene-proprete',
    'gsf-rouen-ptl',
    'nexity-reiwa',
    'sgar',
    'alstom-saint-ouen',
    'eid-mediterrannee',
    'mairie-sainte-genies-bellevue',
    'pum-coignieres',
    'tribunaux-78',
    'fdme',
    'atalian-caf',
    'crous31',
    'testgui',
    'saipem',
    'workspaceasupprimer',
    'ville-rosny',
    'dpd-gennevilliers',
    'kyriad-st-maurice',
    'climb-up',
    'lfg-paris',
    'arsene-taxand',
    'crous-aix',
    'mairie-brie-comte-robert',
    'mmpackaging',
  ].includes(workspace);
}

// export const getMaximumLocationsLevel = workspace => {
//   const maximumLocationsLevels = {
//     "alicia": 3
//   };
//   return maximumLocationsLevels[workspace] || 1;
// };
